module.exports = __webpack_public_path__ + "img/jigou2.3575b211.png";